import { useState, useEffect, useRef } from "react";
import styles from "./dropdownfilter.module.css"; // reuse or adjust CSS

const DropdownImageTrigger = ({
	iconSrc, // image path
	altText = "menu",
	options = [], // [{ label, action, disabled }]
	iconClass = "",
	menuClass = "",
	onTriggerClick,
}) => {
	const [isOpen, setIsOpen] = useState(false);
	const dropdownRef = useRef(null);

	useEffect(() => {
		const handleClickOutside = (event) => {
			if (
				dropdownRef.current &&
				!dropdownRef.current.contains(event.target)
			) {
				setIsOpen(false);
			}
		};
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, []);

	const handleOptionClick = (option, event) => {
		event?.stopPropagation();
		if (option?.disabled) {
			return;
		}
		const action = option?.action;
		if (typeof action === "function") {
			action();
		}
		setIsOpen(false);
	};

	const handleTriggerClick = () => {
		if (typeof onTriggerClick === "function") {
			const shouldOpen = onTriggerClick();
			if (shouldOpen === false) {
				return;
			}
		}
		setIsOpen((prev) => !prev);
	};

	return (
		<div ref={dropdownRef} className={`${styles.dropdownWrapper || ""}`}>
			<div className="icon" onClick={handleTriggerClick}>
				<img
					src={iconSrc}
					alt={altText}
					className={iconClass}
				/>
			</div>

			{isOpen && (
				<ul className={menuClass}>
					{options.map((option, index) => (
						<li
							key={index}
							className={`${styles.dropdownItem || ""} ${option?.disabled ? styles.disabledItem : ""}`}
							onClick={(event) => handleOptionClick(option, event)}
							title={option?.tooltip || ""}>
							{option.label}
						</li>
					))}
				</ul>
			)}
		</div>
	);
};

export default DropdownImageTrigger;
